
export default {
  brandHeadingText: name => `Hello, I'm ${name}`,
  slogan: 'Your local software engineer' +
    ' ' +
    // 'in the Ontario and L.A. area' +
    // ' ' +
    'specializing in hand-crafted custom responsive websites'
};



// WEBPACK FOOTER //
// ./src/components/intro/intro.js